import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { ACCOUNT_TYPE } from '@tencent/ark-utils/lib/base/types';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
import { setBPersonAccountIdMap } from '@tencent/ark-utils/lib/storage/account-id-map';
import { wdocsUserCenter } from '@tencent/wdocs-user-center';
import EnterpriseAccountAggregate from '../model/aggregate/enterprise-account-aggregate';
import { NOT_LOGIN_TINYID, } from '../model/value-object/user-info/user-info.interface';
import UserInfoRepository from '../repository/user-info';
var EnterpriseAccountDomainService = /** @class */ (function () {
    function EnterpriseAccountDomainService(networkRequestService) {
        var _this = this;
        this.networkRequestService = networkRequestService;
        this.updateBLocalStoragePersionTinyid = function (userInfo) { return __awaiter(_this, void 0, void 0, function () {
            var userMarkNameList, wedriveUin;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(userInfo.loginType === ACCOUNT_TYPE.WX && userInfo.tinyid)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accountAggregate.enterpriseAccountListEntity
                                .getUserMarkNameListByUids([userInfo.tinyid])];
                    case 1:
                        userMarkNameList = _b.sent();
                        wedriveUin = (_a = userMarkNameList[0]) === null || _a === void 0 ? void 0 : _a.wedriveUin;
                        if (wedriveUin) {
                            setBPersonAccountIdMap({
                                wedriveUin: wedriveUin,
                                tinyid: userInfo.tinyid,
                            });
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.userInfoRepository = new UserInfoRepository(this.networkRequestService);
    }
    /**
     * 初始化企业微信账号领域
     * 无需统一初始化，提供空实现
     * 如若想初始化账号相关的数据，请查看接入文档：https://iwiki.woa.com/pages/viewpage.action?pageId=1902350186
     */
    EnterpriseAccountDomainService.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    EnterpriseAccountDomainService.prototype.createEnterpriseEnvAccountAggregateByBasicClientVars = function (userInfo) {
        if (userInfo) {
            this.accountAggregate = new EnterpriseAccountAggregate(this.networkRequestService, userInfo.tinyId || NOT_LOGIN_TINYID, this.changeBasicClientVarsToBaseData(userInfo));
            return true;
        }
        this.accountAggregate = new EnterpriseAccountAggregate(this.networkRequestService, NOT_LOGIN_TINYID);
        return false;
    };
    // 通过 user_info 更新补充数据
    EnterpriseAccountDomainService.prototype.completionUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userInfoRepository.getEnterpriseUserInfo()];
                    case 1:
                        data = _a.sent();
                        if (data) {
                            // 备注：b端user_info接口缺失了vip_info和wechat_official_account字段
                            this.accountAggregate.completionUserInfo(data);
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    EnterpriseAccountDomainService.prototype.createEnterpriseEnvAccountAggregateByUserInfoCgi = function (userInfo) {
        var baseData = this.changeFetchDataToBaseData(userInfo);
        this.accountAggregate = new EnterpriseAccountAggregate(this.networkRequestService, baseData.tinyId, baseData);
    };
    EnterpriseAccountDomainService.prototype.changeBasicClientVarsToBaseData = function (userInfo) {
        var baseData = __assign({}, userInfo);
        return baseData;
    };
    EnterpriseAccountDomainService.prototype.changeFetchDataToBaseData = function (userInfo, language) {
        this.updateBLocalStoragePersionTinyid(userInfo);
        var corpId = userInfo.corpId, tinyid = userInfo.tinyid, corpName = userInfo.corpName, englishName = userInfo.englishName, loginType = userInfo.loginType, wxOpenid = userInfo.wxOpenid, uin = userInfo.uin, uidSource = userInfo.uidSource, userId = userInfo.userId, avatar = userInfo.avatar, nick = userInfo.nick;
        // 微信用户userInfo里是tinyid找不到对应的用户，用xid再试一遍
        var user = wdocsUserCenter.get(userInfo.uid) || wdocsUserCenter.get(userInfo.xid || '');
        var baseData = {
            corpId: corpId,
            corpName: corpName,
            englishName: englishName,
            loginType: loginType,
            uin: uin,
            uidSource: uidSource,
            userId: userId,
            tinyId: tinyid,
            openId: wxOpenid,
            userName: nick,
            userPic: avatar,
            // 这里预期是uid，但是userInfo里如果是腾讯会是vid，从usercenter里换一下uid
            wedriveUin: (user === null || user === void 0 ? void 0 : user.uid) || userInfo.uid,
            nowUserIndex: '',
            settings: {
                language: language !== null && language !== void 0 ? language : '',
                toolbarMode: '',
                vipTheme: '',
                openWithDesktop: '',
            },
            wedocOpenId: userInfo.openid,
        };
        return baseData;
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], EnterpriseAccountDomainService.prototype, "init", null);
    EnterpriseAccountDomainService = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], EnterpriseAccountDomainService);
    return EnterpriseAccountDomainService;
}());
export { EnterpriseAccountDomainService };
